import { z } from 'zod';
/** 모든 이벤트가 공유하는 봉투 — outbox headers 와 1:1 대응한다 (아키텍처 §4.3). */
export const envelopeSchema = z.object({
    messageId: z.uuid(),
    eventName: z.string().min(1),
    eventVersion: z.int().positive(),
    occurredAt: z.iso.datetime(),
    traceparent: z.string().min(1).optional(),
    correlationId: z.string().min(1),
    causationId: z.string().min(1).optional(),
    producer: z.string().min(1),
});
